import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { healthCheckCertificateUrl } from '@app/definition/API';
import useLoadData from '@app/common/loadData/useLoadData';
import { ResultI } from './types';

type UseCertitifaceDataReturnType = {
  loading: boolean;
  error: boolean;
  resultData: ResultI;
};

const useCertitifaceData = (token: string): UseCertitifaceDataReturnType => {
  const dispatch = useDispatch();
  const initialState = useMemo(
    () =>
      ({
        firstName: '',
        lastName: '',
        result: 'indeterminate',
        birthdate: '',
        passportNumber: '',
        arrivalDate: 0,
        sampleTakenAt: 0,
        reportedAt: 0,
        analysedAt: 0,
        testType: '',
        testCategory: '',
        sampleType: '',
      } as ResultI),
    []
  );
  const [resultData, setResultData] = useState<ResultI>(initialState);
  const { error, loading, loadData } = useLoadData<ResultI>();

  useEffect(() => {
    const fetchData = async () => {
      const requestUrl = `${healthCheckCertificateUrl}/${token}`;
      const data = await loadData(requestUrl);
      if (!data.error && data.data) {
        setResultData(data.data);
      }
    };
    fetchData();
  }, [dispatch, loadData, setResultData, initialState, token]);

  return {
    resultData,
    loading,
    error,
  };
};

export default useCertitifaceData;
